import React from 'react';

import CardTriagem from './Cards/CardTriagem';
import CardCadastro from './Cards/CardCadastro';
import CardAtendimentoMedico from './Cards/CardAtendimentoMedico';
import CardReavaliacaoMedica from './Cards/CardReavaliacaoMedica';
import CardMedicacao from './Cards/CardMedicacao';
import CardExamesLaboratoriais from './Cards/CardExamesLaboratoriais';
import CardExamesImagem from './Cards/CardExamesImagem';
import CardInternacao from './Cards/CardInternacao';
import CardTriagemDetalhe from './Cards/CardTriagemDetalhe';
import CardCadastroDetalhe from './Cards/CardCadastroDetalhe';
import CardAtendimentoMedicoDetalhe from './Cards/CardAtendimentoMedicoDetalhe';
import CardReavaliacaoMedicaDetalhe from './Cards/CardReavaliacaoMedicaDetalhe';
import CardMedicacaoDetalhe from './Cards/CardMedicacaoDetalhe';
import CardExamesLaboratoriaisDetalhe from './Cards/CardExamesLaboratoriaisDetalhe';
import CardExamesImagemDetalhe from './Cards/CardExamesImagemDetalhe';
import CardInternacaoDetalhe from './Cards/CardInternacaoDetalhe';
import { isFilaInfantil } from '../rules/regraFilaPS';

const CardsList = [
  {
    tipo: 1,
    dataKey: 'pacientesAguardandoTriagem',
    title: 'Pacientes Aguardando Triagem',
    titleShort: 'Triagem',
    card: (props) => <CardTriagem {...props} />,
    detalhe: (props) => <CardTriagemDetalhe {...props} />,
    regras: {
      isPediatria: (item) => isFilaInfantil(1, item),
    }
  },
  {
    tipo: 2,
    dataKey: 'pacientesAguardandoCadastro',
    title: 'Pacientes Aguardando Cadastro',
    titleShort: 'Cadastro',
    card: (props) => <CardCadastro {...props} />,
    detalhe: (props) => <CardCadastroDetalhe {...props} />,
    regras: {
      isPediatria: (item) => isFilaInfantil(2, item),
    }
  },
  {
    tipo: 3,
    dataKey: 'pacientesAguardandoAtendimentoMedico',
    title: 'Pacientes Aguardando Atendimento Médico',
    titleShort: 'Atendimento Médico',
    card: (props) => <CardAtendimentoMedico {...props} />,
    detalhe: (props) => <CardAtendimentoMedicoDetalhe {...props} />,
    regras: {
      isPediatria: (item) => isFilaInfantil(3, item),
    }
  },
  {
    tipo: 4,
    dataKey: 'pacientesAguardandoReavaliacaoMedico',
    title: 'Pacientes Aguardando Reavaliação Médica',
    titleShort: 'Reavaliação Médica',
    card: (props) => <CardReavaliacaoMedica {...props} />,
    detalhe: (props) => <CardReavaliacaoMedicaDetalhe {...props} />,
    regras: {
      isPediatria: (item) => isFilaInfantil(4, item),
    }
  },
  {
    tipo: 5,
    dataKey: 'pacientesAguardandoMedicao',
    title: 'Pacientes Aguardando Medicação',
    titleShort: 'Medicação',
    card: (props) => <CardMedicacao {...props} />,
    detalhe: (props) => <CardMedicacaoDetalhe {...props} />,
    regras: {
      isPediatria: (item) => isFilaInfantil(5, item),
    }
  },
  {
    tipo: 6,
    dataKey: 'pacientesAguardandoExamesLaboratoriais',
    title: 'Pacientes Aguardando Exames Laboratoriais',
    titleShort: 'Exames Laboratoriais',
    card: (props) => <CardExamesLaboratoriais {...props} />,
    detalhe: (props) => <CardExamesLaboratoriaisDetalhe {...props} />,
    regras: {
      isPediatria: (item) => isFilaInfantil(6, item),
    }
  },
  {
    tipo: 7,
    dataKey: 'pacientesAguardandoExamesDeImagem',
    title: 'Pacientes Aguardando Exames de Imagem',
    titleShort: 'Exames de Imagem',
    card: (props) => <CardExamesImagem {...props} />,
    detalhe: (props) => <CardExamesImagemDetalhe {...props} />,
    regras: {
      isPediatria: (item) => isFilaInfantil(7, item),
    }
  },
  {
    tipo: 8,
    dataKey: 'pacientesAguardandoInternacao',
    title: 'Pacientes Aguardando Internação',
    titleShort: 'Internação',
    card: (props) => <CardInternacao {...props} />,
    detalhe: (props) => <CardInternacaoDetalhe {...props} />,
    regras: {
      isPediatria: (item) => isFilaInfantil(8, item),
    }
  },
];

export default CardsList